@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.single-order-header {
  padding: 5px 5px 5px 10px;
  background-color: @orders-drawer--default--header--background-color;
  border: 1px solid @orders-drawer--default--header--border-color;
  display: flex;
  justify-content: space-between;
}

.header-actions {
  display: flex;
  align-items: center;
}
